import { Skeleton } from '@ah/design';

export function CircleListSkeleton() {
  return (
    <div className="space-y-3">
      {Array.from({ length: 5 }, (_, i) => (
        <div key={i} className="flex gap-3 p-3 bg-card rounded-xl border border-border">
          <Skeleton className="w-12 h-12 rounded-full shrink-0" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function ErrorRetry({ label, onRetry }: { label: string; onRetry: () => void }) {
  return (
    <div className="text-center py-16">
      <p className="text-sm text-destructive mb-3">{label}</p>
      <button
        type="button"
        onClick={onRetry}
        className="text-sm px-3 py-1.5 rounded-full border border-border bg-card hover:bg-accent"
      >
        Retry
      </button>
    </div>
  );
}

export function relativeTime(dateStr: string): string {
  const now = Date.now();
  const then = new Date(dateStr).getTime();
  const secs = Math.floor((now - then) / 1000);
  if (secs < 60) return 'just now';
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d`;
  return new Date(dateStr).toLocaleDateString();
}
